import apinode from '../../apinode'

class LeroyMerlinService {
  constructor() {
    this.idconta = localStorage.idconta
  }

  //? Busca contas leroys cadastradas no banco de dados, por isso não precisa da chave da api
  async getAccounts() {
    const response = await apinode.get(`/leroymerlin/accounts/${this.idconta}`)

    return response.data
  }

  //? Busca as hierarquias disponíveis para envio de produtos (categorias)
  async getHierarchies(apiLeroyKey) {
    const response = await apinode.get(`/leroymerlin/hierarchies`, {
      headers: {
        'API-KEY-LEROY': apiLeroyKey,
      },
    })

    const options = response.data.hierarchies.map((hierarchy) => ({
      value: hierarchy.code,
      label: hierarchy.label,
    }))

    return options.toSorted((a, b) => a.label.localeCompare(b.label))
  }

  //? Busca os pedidos
  async getOrders(apiLeroyKey) {
    const response = await apinode.get(`/leroymerlin/orders/${this.idconta}`, {
      headers: {
        'API-KEY-LEROY': apiLeroyKey,
      },
    })

    return response.data
  }

  //? Gera arquivo excel pra envio de produtos via CSV
  async generateExcelFile(codProducts, hierarchy) {
    await apinode.post(`/leroymerlin/${this.idconta}/products/file/generate`, {
      codProducts,
      hierarchy,
    })
  }

  //? Importa os pedidos da Leroy pro nosso banco de dados
  async importOrder(orderId, apiLeroyKey) {
    await apinode.post(`/leroymerlin/orders/${orderId}/${this.idconta}`, null, {
      headers: {
        'API-KEY-LEROY': apiLeroyKey,
      },
    })
  }

  async sendOffer(data, apiLeroyKey) {
    const response = await apinode.post(
      '/leroymerlin/offers',
      { data },
      {
        headers: {
          'API-KEY-LEROY': apiLeroyKey,
        },
      },
    )

    return response.data.importId
  }

  //? Envia o arquivo CSV para cadastro de produtos
  async sendFile(file, apiLeroyKey) {
    const formData = new FormData()

    formData.append('file', file)

    const response = await fetch(
      `${process.env.REACT_APP_BACKEND_API}/leroymerlin/products/exports`,
      {
        body: formData,
        method: 'POST',
        headers: {
          'API-KEY-LEROY': apiLeroyKey,
        },
      },
    )

    const data = await response.json()

    return data
  }
}

export default new LeroyMerlinService()
